module.exports = __webpack_public_path__ + "img/default-avatar-patient.fe15f042.png";